"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PatternCropRotatePipeline = void 0;

var _glCore = require("@capture/gl-core");

var _PatternCropOverlayFilter = _interopRequireDefault(require("./overlayFilters/PatternCropOverlayFilter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class PatternCropRotatePipeline extends _glCore.GLSquareCropRotatePipeline {
  constructor() {
    const cropOverlayFilter = new _PatternCropOverlayFilter.default();
    super([cropOverlayFilter, new _glCore.GLCopyFilter()]);
    this.cropOverlayFilter = cropOverlayFilter;
  }

  setPatternType(type) {
    this.cropOverlayFilter.patternType = type;
  }

  getPatternType() {
    return this.cropOverlayFilter.patternType;
  }

  drawOffScreen(gl, texture, viewWidth, viewHeight, textureWidth, textureHeight, flip) {
    this.cropOverlayFilter.isEnabled = false;
    const result = super.drawOffScreen(gl, texture, viewWidth, viewHeight, textureWidth, textureHeight, true);
    this.cropOverlayFilter.isEnabled = true;
    return result;
  }

}

exports.PatternCropRotatePipeline = PatternCropRotatePipeline;

var _default = new PatternCropRotatePipeline();

exports.default = _default;